import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { ResearcherCertificate } from "../model/researcher-certificate";

@Injectable({
  providedIn: 'root'
})
export class ResearchersCertificatesService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.researcherCertificates;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllResearcherCertificates(): Observable<ResearcherCertificate[]> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`)
      .pipe(map(value => value.data as ResearcherCertificate[]));
  }

  public getResearcherCertificate(id: number): Observable<ResearcherCertificate> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(value => value.data as ResearcherCertificate));
  }

  public createResearcherCertificate(certificate: ResearcherCertificate): Observable<ResearcherCertificate> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, certificate)
      .pipe(map(value => value.data as ResearcherCertificate));
  }

  public updateResearcherCertificate(certificate: ResearcherCertificate): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${certificate.id}`, certificate)
      .pipe(map(() => { }));
  }

  public deleteResearcherCertificate(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }


}
